/**
 * Exibe um toastr de sucesso
 */
export const success = function(message = 'Ação realizada com sucesso') {

    toastr.success(
        message,
        'Atenção!',
        {timeout: 5000, closeButton:true, progressBar: true}
    )
}

/**
 * Exibe um toastr de info
 */
export const info = function(message = 'Ação realizada com sucesso') {

    toastr.info(
        message,
        'Atenção!',
        {timeout: 5000, closeButton:true, progressBar: true}
    )
}

/**
 * Exibe um toastr de warning
 */
export const warning = function(message = 'Ação realizada com sucesso') {

    toastr.warning(
        message,
        'Atenção!',
        {timeout: 5000, closeButton:true, progressBar: true}
    )
}

/**
 * Usado para mostrar um toastr de erro
 * @param data
 */
export const error = function(data) {
    let message = data.error ?? 'Seu formulário possui erros. Corrija e envie novamente.'
    toastr.error(
        message,
        'Atenção!',
        {timeout: 5000, closeButton:true, progressBar: true}
    )
}
